<template>
  <div
    id="modalCodeEditorId"
    class="modal-code-editor">
    <!-- Header -->
    <div class="modal-code-editor__header">
      <div class="modal-code-editor__header__title">
        <img src="@/assets/new-form-ui/code-editor.svg" >
        <div class="title">Code Editor</div>
        <div class="title">{{ viewTitle }}</div>
      </div>
      <p
        class="modal-code-editor__header__icon"
        @click="$emit('close')"
      >
        &times;
      </p>
    </div>

    <div class="modal-code-editor__content">
      <b-form>
        <label> Script </label>
        <j-monaco-editor
          v-if="isShowEditor"
          ref="scriptEditor"
          :value="viewData"
          language="json"
          height="calc(90vh - 150px)"
        />
      </b-form>
    </div>

    <div class="modal-code-editor__footer">
      <button
        class="button-border"
        @click="$emit('close')"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="update"
      >
        Update
      </button>
    </div>
  </div>
</template>

<script>
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import { mapActions } from 'vuex';

export default {
  components: {
    jMonacoEditor,
  },

  props: {
    viewTitle: {
      type: String,
      default: '',
    },
    viewData: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isShowEditor: false,
    };
  },

  mounted() {
    setTimeout(() => { this.isShowEditor = true; }, 100);
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    update() {
      try {
        this.$emit('update', JSON.parse(this.$refs.scriptEditor.getData()), this.type);
      } catch (err) {
        this.toggleProblem('JSON not valid');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalCodeEditor.vue